import React, { memo, useState, ChangeEvent, FormEvent } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { Autocomplete } from 'transfix-ui/components/Autocomplete'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'

export interface ISMSInputProps {
  submit: Function
  error?: string
  sending?: boolean
  cannedMessages?: any[]
}

export const SMSInput = memo<ISMSInputProps>(({ cannedMessages, error, sending, submit }) => {
  const [text, setText] = useState('')
  const onChange = ({ target: { value } }: ChangeEvent<HTMLTextAreaElement>) => setText(value)
  const onChangeSelect = (_: React.ChangeEvent<{}>, selected: ISelectOption<string>) =>
    setText(selected?.value || '')
  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    submit(text)
    setText('')
  }
  return (
    <>
      <form name='sms-form' onSubmit={onSubmit}>
        {cannedMessages && (
          <div className='mb4'>
            <Autocomplete
              options={cannedMessages}
              onChange={onChangeSelect}
              dataTest='select-sms-input'
              getOptionLabel={option => option.label}
              placeholder='Select a Message'
              clearable
            />
          </div>
        )}
        <div className='mb4'>
          <textarea
            placeholder='Write something...'
            name='message'
            data-test='message-body'
            value={text}
            required
            onChange={onChange}
          />
        </div>
        <div className='mb4'>
          <button
            className='btn-primary'
            disabled={!text || sending}
            data-test='message-submit'
            type='submit'>
            {sending ? 'Sending...' : 'Send SMS'}
          </button>
        </div>
        {error && (
          <InlineMessage
            message='Message failed to send. Please try again.'
            type={INLINE_MESSAGE_VARIANTS.ALERT}
          />
        )}
      </form>
    </>
  )
})
